<script>
    const statusToBootstrap = {
        warn: 'warning',
        error: 'danger',
        info: 'info',
        success: 'success'
    }
    export let alerts

    // prettier-ignore
    const removeAlert = (index) => {
        alerts = [
            ...alerts.slice(0, index),
            ...alerts.slice(index + 1)
        ]
    }
</script>

{#if alerts && alerts.length}
    <div class="mt-3">
        <hr />
        {#each alerts || [] as alert, index}
            <div
                class="alert alert-{statusToBootstrap[alert.level || 'error']} alert-dismissible fade show"
                role="alert"
            >
                {#if alert.error}
                    {#if alert.error.code}<strong>{alert.error.code}</strong>{/if}
                    {alert.error.detail || alert.error.title || 'Unexpected Error'}
                    {#if alert.error.detail && alert.error.title}
                        <p class="text-muted">{alert.error.title}</p>
                    {:else}
                        <pre>{JSON.stringify(alert.error)}</pre>
                    {/if}
                {:else}
                    <p>Unexpected Error!</p>
                {/if}
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="alert"
                    aria-label="Close"
                    on:click={() => removeAlert(index)}
                />
            </div>
        {/each}
    </div>
{/if}
